import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import "./Ticket.css";
import { FaTimes } from "react-icons/fa";
import { useProfile } from '../../Context/ProfileContext';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from 'react-i18next';
import useLanguage from '../../Hooks/useLanguage';
function TicketDetail() {
    const { id } = useParams();
    const [ticket, setTicket] = useState(null);
    const [loading, setLoading] = useState(true);
    const [replyMessage, setReplyMessage] = useState("");
    const [error, setError] = useState(null);
    const [isReopenFormVisible, setIsReopenFormVisible] = useState(false);
    const { profile } = useProfile();
    useLanguage();
    const { t } = useTranslation();
    useEffect(() => {
        const fetchTicket = async () => {
            try {
                const token = Cookies.get('Token');
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/v1/ticket-reply/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setTicket(response?.data);
            } catch (err) {
                console.error("Error fetching ticket:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchTicket();
    }, [id]);

    const handleReplySubmit = async (e) => {
        e.preventDefault();
        try {
            const token = Cookies.get('Token');
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v1/ticket-reply/${id}/replyuser`,
                { message: replyMessage },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const newReply = {
                ...response.data,
                admin: response.data.admin || false,
                admin_name: response.data.admin ? response.data.admin_name || "Operator" : "User",
                user_name: response.data.user_name || "User",
            };

            setTicket((prevTicket) => ({
                ...prevTicket,
                replies: [...prevTicket.replies, newReply],
            }));

            setReplyMessage("");

        } catch (err) {
            setError("Không thể gửi phản hồi. Vui lòng thử lại.");
            console.error("Error sending reply:", err);
        }
    };


    const handleCloseTicket = async () => {
        try {
            const token = Cookies.get('Token');
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v1/ticket-reply/${id}/close`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setTicket((prevTicket) => ({ ...prevTicket, status: 3 }));
        } catch (err) {
            console.error("Error closing ticket:", err);
            setError("Không thể đóng ticket. Vui lòng thử lại.");
        }
    };

    const handleReopenTicket = async () => {
        try {
            const token = Cookies.get('Token');
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v1/ticket-reply/${id}/reopen`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setTicket((prevTicket) => ({ ...prevTicket, status: 0 }));
        } catch (err) {
            console.error("Error reopening ticket:", err);
            setError("Không thể mở lại ticket. Vui lòng thử lại.");
        }
    };


    if (loading) {
        return <p className="ticket-detail-loading">Đang tải dữ liệu...</p>;
    }

    if (!ticket) {
        return <p className="ticket-detail-loading">Không tìm thấy dữ liệu ticket.</p>;
    }

    return (
        <div className="ticket-detail-body">
            <div className='row'>
                <div className='col-3'>
                    <div className="ticket-detail-container card p-4 shadow-sm">
                        <h3 className="card-title text-primary mb-4 text-center">{t("Ticket information")}</h3>

                        <div className="ticket-detail-content">
                            <div className="d-flex justify-content-between mb-3">
                                <span className="fw-bold">{t("Title")}</span>
                                <span>{ticket.subject}</span>
                            </div>

                            <div className="d-flex flex-column mb-3">
                                <span className="fw-bold mb-2">{t("Content")}</span>
                                <div className="text-secondary" dangerouslySetInnerHTML={{ __html: ticket.message }}></div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span className="fw-bold">{t("Status")}:</span>
                                <span
                                    className="status-text"
                                    style={{
                                        color: ticket.status === 0 ? '#28A745' :
                                            ticket.status === 1 ? '#FFC107' :
                                                ticket.status === 2 ? '#007bff' :
                                                    ticket.status === 3 ? '#A71D2A' : '#FD7E14',
                                        fontWeight: 'bold',
                                    }}>
                                    {ticket.status === 0 ? t("Open") :
                                        ticket.status === 1 ? t("Answered") :
                                            ticket.status === 2 ? t("Customer Reply") :
                                                ticket.status === 3 ? t("Closed") :
                                                    t("In Progress")}
                                </span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                            {ticket.status === 3 ? (
                                <button className="custom-btn btn-success" onClick={handleReopenTicket}>
                                    {t("Open ticket")}
                                </button>
                            ) : (
                                <button className="custom-btn btn-danger" onClick={handleCloseTicket}>
                                    {t("Close ticket")}
                                </button>
                            )}
                        </div>

                    </div>


                </div>
                <div className='col-9'>

                    <div className="ticket-user-message card p-3 mb-4 shadow-sm ">
                        <div className="ticket-user-info">
                            <div className="d-flex align-items-center mb-2">
                                <div className='ticket-reply-info-group'>
                                    <svg className="ticket-reply-avatar" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#28a745">
                                        <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
                                    </svg>
                                    <span className="ms-2">
                                        <strong>{profile?.name}</strong>
                                        <span className="ticket-reply-badge user-badge ms-2">Owner</span>
                                    </span>


                                </div>

                                <span className="ticket-reply-date">
                                    {new Date(ticket.date).toLocaleDateString('vi-VN', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                    })}
                                </span>
                            </div>
                            <hr style={{ margin: "0px", padding: "0px", position: "relative", top: "0px" }}></hr>

                            <div className='body'>
                                <span dangerouslySetInnerHTML={{ __html: ticket.message }}></span>

                            </div>
                        </div>
                    </div>


                    {ticket.replies.length > 0 ? (
                        <ul className="ticket-detail-replies-list">
                            {ticket.replies.map((reply) => (
                                <li className={`ticket-detail-reply-item ${reply.admin ? "ticket-reply-admin" : "ticket-reply-user"}`} key={reply.id}>
                                    <div className="ticket-reply-header">
                                        <div className="ticket-reply-info-group">
                                            <span>
                                                {reply.admin ? (
                                                    <svg className="ticket-reply-avatar" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#007bff">
                                                        <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
                                                    </svg>
                                                ) : (
                                                    <svg className="ticket-reply-avatar" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#28a745">
                                                        <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5z" />
                                                    </svg>
                                                )}
                                            </span>

                                            <span className="ticket-reply-info">
                                                <strong>{reply.admin ? reply.admin_name : profile.name}</strong>
                                                <span className={`ticket-reply-badge ${reply.admin ? "admin-badge" : "user-badge"}`}>
                                                    {reply.admin ? "Operator" : "Owner"}
                                                </span>
                                            </span>
                                        </div>

                                        <span className="ticket-reply-date">
                                            {new Date(reply.date).toLocaleDateString('vi-VN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                            })}
                                        </span>
                                    </div>

                                    <hr style={{ margin: "0px", padding: "0px", position: "relative", top: "px" }}></hr>
                                    <div className='body' dangerouslySetInnerHTML={{ __html: reply.message }}></div>

                                </li>

                            ))}
                        </ul>

                    ) : (
                        <p className="ticket-detail-paragraph">Chưa có phản hồi nào.</p>
                    )}
                    {ticket.status !== 3 || isReopenFormVisible ? (
                        <>
                            <form className="ticket-reply-form" onSubmit={handleReplySubmit}>
                                {error && <p className="ticket-reply-error">{error}</p>}
                                <div className="form-group">
                                    <label>{t("Send feedback")}</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={replyMessage}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setReplyMessage(data);
                                        }}
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary">{t("Send feedback")}</button>
                            </form>
                        </>
                    ) : (
                        <div className="ticket-closed-container">
                            <p className="ticket-closed-message">Ticket này đang đóng. Bạn có thể chọn chức năng "Mở ticket" để mở lại ticket.</p>
                            {/* <button className="ticket-reopen-button" onClick={() => setIsReopenFormVisible(true)}>Trả lời</button> */}
                        </div>
                    )}
                </div>
            </div>









        </div>
    );
}

export default TicketDetail;